import cx from 'classnames'
import { MdWarningAmber } from 'react-icons/md'

import { FriendlyDateTime } from '../../../shared/Date/friendly-date-time'

import styles from './warning.module.scss'

export function Warning ({ type, subTitle = '', title, data, withMargin, style, className, infoStyle }) {
  return (
    <div
      className={cx(styles.warning, className, {
        [styles.withMargin]: withMargin,
        [styles[type]]: type
      })}
      style={style}
    >
      <div className={styles.block}>
        {type === 'concurrent'
          ? (
            <MdWarningAmber
              color='#E4980F'
              size='1.4rem'
            />
          )
          : (
            <MdWarningAmber
              size='1.4rem'
              color='#D04437'
            />
          )}
      </div>
      <div className={styles.info} style={infoStyle}>
        <pre className={styles.title}>{title}</pre>
        {!!subTitle.length && (
          <p className='text-md text-zinc-600'>{subTitle}</p>
        )}

        {type === 'outdated' && (
          <div className={styles.bottom}>
            Please discard your changes to see the most recent version (your draft
            changes will NOT be saved)
          </div>
        )}
        {data && (
          <div className={styles.subTitle}>
            {data?.map(d => (
              <div key={d.name}>
                <span className={styles.name}>
                  {d.name}
                  {' '}
                  <span className={styles.label}>
                    {type === 'concurrent' ? 'created' : 'published'}
                  </span>
                  <span className={styles.date}>
                    <FriendlyDateTime datetime={d.created} />
                  </span>
                  {type === 'concurrent' && (
                    <>
                      <span className={styles.label}>updated</span>
                      <span className={styles.date}>
                        <FriendlyDateTime datetime={d.updated} />
                      </span>
                    </>
                  )}
                </span>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  )
}
